import {
  HostBinding,
  Component,
  OnInit,
  AfterViewInit,
  ViewChild,
  ChangeDetectorRef,
  HostListener,
} from '@angular/core';
import { routerTransition } from 'app/shared/animations/router-transition.animation';
import { environment } from '../../../environments/environment';


@Component({
  selector: 'app-grupo-ceuma',
  templateUrl: './grupo-ceuma.component.html',
  styleUrls: ['./grupo-ceuma.component.scss'],
  animations: [routerTransition],
})
export class GrupoCeumaComponent implements OnInit, AfterViewInit {
  @HostBinding('@routerTransition') routerTransition = true;
  @HostBinding('style.display') display = 'block';

  @ViewChild('boxTimeline') boxTimeline;

  environment = environment;


  itensTimeline = [];
  animarControlesEsquerda = false;
  animarControlesDireita = false;
  animacaoControle = 500;

  posicaoTimeline = -208;
  tamanhoBoxTimeline = 516;

  @HostListener('window:resize', ['$event']) onResize(event) {
    this.calcularEstrutaTimeline();
  }

  constructor(
    private cdr: ChangeDetectorRef,
  ) { }

  ngAfterViewInit() {
    this.calcularEstrutaTimeline();
  }

  calcularEstrutaTimeline() {
    const domBoxTimeline = this.boxTimeline.nativeElement;
    this.tamanhoBoxTimeline = domBoxTimeline.offsetWidth;
    this.posicaoTimeline = -(this.tamanhoBoxTimeline / 2);
    this.cdr.detectChanges();
  }

  ngOnInit() {
    this.itensTimeline = [
      {
        src: '/assets/images/grupo-timeline/1.png',
        data: 'Março, 1990',
        titulo: 'Autorização do Ceuma',
        descricao: 'O engenheiro Mauro Fecury com o presidente da República, José Sarney.',
        active: true,
      },
      {
        src: '/assets/images/grupo-timeline/2.png',
        data: 'Abril, 1990',
        titulo: 'Aula Inaugural',
        descricao: 'Professoras Solange Buzar, Ana Lúcia Chaves Fecury, Ana Maria Saldanha e Zélia Maria Pereira participaram da mesa da solenidade.',
        active: false,
      },
      {
        src: '/assets/images/grupo-timeline/3.png',
        data: 'Março, 1991',
        titulo: 'Sede Própria',
        descricao: 'Início das obras do campus Renascença.',
        active: false,
      },
      {
        src: '/assets/images/grupo-timeline/4.png',
        data: 'Fevereiro, 1992',
        titulo: 'Inauguração Campus Renascença',
        descricao: 'A fachada foi inspirada na Universidade de Coimbra (Portugal), onde estudaram os escritores maranhenses Gonçalves Dias e João Lisboa.',
        active: false,
      },
      {
        src: '/assets/images/grupo-timeline/5.png',
        data: 'Dezembro, 1993',
        titulo: 'Primeira Formatura',
        descricao: 'A presidente da Mantenedora Ceuma, Ana Lúcia Chaves Fecury, faz o discurso de abertura da solenidade.',
        active: false,
      },
      {
        src: '/assets/images/grupo-timeline/6.png',
        data: 'Março, 1995',
        titulo: 'Palestra de Paulo Freire',
        descricao: 'O ilustre pedagogo, entre os profesores Antônio Carlos Beckman, Mateus Antônio da Silva Neto e Luís Anísio Camarão Chaves na Semana de Letras do Ceuma.',
        active: false,
      },
      {
        src: '/assets/images/grupo-timeline/7.png',
        data: 'Agosto, 1998',
        titulo: 'Fundação do Unieuro',
        descricao: 'Inauguração do campus Asa Sul, em Brasília (DF).',
        active: false,
      },
      {
        src: '/assets/images/grupo-timeline/8.png',
        data: 'Junho, 1999',
        titulo: 'Visitante Ilustre',
        descricao: 'O escritor francês Maurice Druon (Academia Francesa de letras) entre José Reinaldo Tavares, José Sarney e Josué Montero durante visita à Universidade Ceuma.',
        active: false,
      },
      {
        src: '/assets/images/grupo-timeline/9.png',
        data: 'Setembro, 2000',
        titulo: 'Reconhecimento',
        descricao: 'Ceuma é credenciado como Centro Universitário pelo MEC.',
        active: false,
      },
      {
        src: '/assets/images/grupo-timeline/10.png',
        data: 'Abril, 2001',
        titulo: 'Inauguração do Campus Cohama',
        descricao: 'Desembargador Jorge Rachid, padre Hélio Maranhão, Prof. Dr. Cabral Marques, desembargador Milson Coutinho e deputado federal Clóvis Fecury.',
        active: false,
      },
      {
        src: '/assets/images/grupo-timeline/11.png',
        data: 'Agosto, 2002',
        titulo: 'Inauguração do Campus Anil',
        descricao: 'Secretário Luis Fernando Silva, presidente da Mantenedora Ana Lúcia Chaves Fecury, governador José Reinaldo Tavares e senador Mauro Fecury.',
        active: false,
      },
      {
        src: '/assets/images/grupo-timeline/12.png',
        data: 'Fevereiro, 2004',
        titulo: 'Aula Inaugural de Medicina',
        descricao: 'Mantenedor Clóvis Fecury entre os palestrantes Cláudio Mouro e Castro e Dr. José Aristodemo Pinotti, ginecologista e político falecido em 2009.',
        active: false,
      },
      {
        src: '/assets/images/grupo-timeline/13.png',
        data: 'Maio, 2005',
        titulo: 'Inauguração do Campus Águas Claras',
        descricao: 'Segundo campus do Centro Unieuro em Brasília (DF).',
        active: false,
      },
      {
        src: '/assets/images/grupo-timeline/14.png',
        data: 'Setembro, 2006',
        titulo: 'Inauguração do Polo Bacabal',
        descricao: 'Reitor Aldy Mello Araújo com a coordenadora Luzinete Pereira.',
        active: false,
      },
      {
        src: '/assets/images/grupo-timeline/15.png',
        data: 'Junho, 2007',
        titulo: 'Premiação Nacional',
        descricao: 'Reitor Aldy Mello de Araújo recebe, em nome da Universidade Ceuma, o Prêmio Brasileiro de Qualidade Educacional 2007, concebido pela Academia Brasileira.',
        active: false,
      },
      {
        src: '/assets/images/grupo-timeline/19.png',
        data: 'Abril, 2011',
        titulo: 'Homenagem ao Primeiro Reitor',
        descricao: 'Universidade Ceuma completa 21 anos e homenageia o Prof. Dr. José Maria Cabral Marques, com um busto na Biblioteca Presidente José Sarney.',
        active: false,
      },
      {
        src: '/assets/images/grupo-timeline/20.png',
        data: 'Março, 2012',
        titulo: 'Comemoração Universidade Ceuma',
        descricao: 'Professores do Campus Anil comemoram a transformação do Centro Universitário do Maranhão Uniceuma em Universidade Ceuma.',
        active: false,
      },
      {
        src: '/assets/images/grupo-timeline/21.png',
        data: 'Março, 2013',
        titulo: 'Inauguração do Campus Imperatriz',
        descricao: 'Coordenador Ricardo Martins, secretário de Educação Pedro Fernandes, prefeito Sebastião Madeira e reitor Marcos Barros.',
        active: false,
      },
      {
        src: '/assets/images/grupo-timeline/22.png',
        data: 'Março, 2014',
        titulo: 'Visita de Sarney ao Campus Imperatriz',
        descricao: 'Visita do ex-presidente da República José Sarney ao Campus Imperatriz, com o coordenador Ricardo Martins, o secretário de Minas e Energia Ricardo Guterres e Clóvis Fecury.',
        active: false,
      },
      {
        src: '/assets/images/grupo-timeline/23.png',
        data: 'Janeiro, 2015',
        titulo: 'Reconhecimento',
        descricao: 'Universidade Ceuma é reconhecida pelo MEC como melhor universidade do Maranhão.',
        active: false,
      },
      {
        src: '/assets/images/grupo-timeline/24.png',
        data: 'Abril, 2015',
        titulo: 'Posse do Atual Reitor',
        descricao: 'Reitor da Universidade Ceuma, Prof. Me. Saulo Martins, entre os dirigentes do Grupo Educacional Ceuma Barros, José Azzolini e Sérgio Tavares.',
        active: false,
      },
    ];
  }

  anterior() {
    if (!this.isPrimeiroAtivo()) {
      this.animarControlesDireita = true;
      setTimeout(() => {
        this.avitarAnterior();
        this.irParaDireita();

        setTimeout(() => this.animarControlesDireita = false, 1200);
      }, 300);
    }
  }

  proximo() {
    if (!this.isUltimoAtivo()) {
      this.animarControlesEsquerda = true;
      setTimeout(() => {
        this.avitarProximo();
        this.irParaEsquerda();

        setTimeout(() => this.animarControlesEsquerda = false, 1200);
      }, 300);
    }
  }

  avitarProximo() {
    const ativo = this.indiceAtivo();

    this.desativarTodos();
    this.ativarProximoIndice(ativo);
  }

  avitarAnterior() {
    const ativo = this.indiceAtivo();

    this.desativarTodos();
    this.ativarIndiceAnterior(ativo);
  }

  indiceAtivo() {
    for (let i = 0; i < this.itensTimeline.length; i++) {
      if (this.itensTimeline[i].active) {
        return i;
      }
    }
  }

  indiceUltimo() {
    return this.itensTimeline.length - 1;
  }

  irParaEsquerda() {
    this.posicaoTimeline = (this.posicaoTimeline - this.tamanhoBoxTimeline);
  }

  irParaDireita() {
    this.posicaoTimeline = (this.posicaoTimeline + this.tamanhoBoxTimeline);
  }

  isUltimoAtivo() {
    return this.indiceAtivo() === this.indiceUltimo();
  }

  isPrimeiroAtivo() {
    return this.indiceAtivo() === 0;
  }

  ativarProximoIndice(indiceAtual) {
    this.itensTimeline[indiceAtual + 1].active = true;
  }

  ativarIndiceAnterior(indiceAtual) {
    this.itensTimeline[indiceAtual - 1].active = true;
  }

  desativarTodos() {
    this.itensTimeline = this.itensTimeline.map((item) => {
      item.active = false;
      return item;
    });
  }
}
